const content = `
    shortDescription
`

const magentoBundleOptions = `
    id
    quantity
    value
`

const attributeSets = `
    size
    comfortLevel
    mattressHeight
    sidePanel
    chairOption
    quiltOption
    color
    fabric
    material
    foundationHeight
    pillowHeightOption
    bathSet
    scent
`

const attribute = `
    code
    value
    label
`

const bundleVariant = `
    productCode
    quantity
    sku
`

const variant = `
    sku
    productCode
    name
    genericName
    category
    subcategory
    productUrl
    variantUrl
    price
    size
    comfortLevel
    mattressHeight
    sidePanel
    chairOption
    quiltOption
    pillowHeightOption
    bathSet
    color
    scent
    fabric
    material
    fabricMaterial
    foundationHeight
    magentoProductType
    attributes {
        ${attribute}
    }
    inStock
    magentoBundleOptions {
        ${magentoBundleOptions}
    }
    hiddenAttributeValues {
        ${attributeSets}
    }
    bundledSkus
    bundledVariants {
        ${bundleVariant}
    }
    assets {
        ardad {
          descriptor
          folder
          filenameBase
          fileExt
        }
    }
`

const product = `
    productCode
    name
    active
    category
    subcategory
    defaultPrice
    lowestPrice
    highestPrice
    attributeSets {
        ${attributeSets}
    }
    url
    content {
        ${content}
    }
    isBundleProduct
    relationships {
        relationshipLabel
        relatedProductCodes
    }
    variants {
        ${variant}
    }
    magentoProductType
    options {
        code
        displayName
        displayType
        default
        values {
            code
            label
            swatch
        }
    }
    configurableAttributes
`

export const GET_PRODUCTS_DATA = `
    query ($productCodes: [String!]!, $modifiers: [ProductModifier]) {
        products(productCodes: $productCodes, modifiers: $modifiers) {
            ${product}
        }
    }
`

export const GET_VARIANTS = `
    query ($skus: [String!]!) {
        variants(skus: $skus) {
            ${variant}
        }
    }
`

export const GET_PRODUCT_MINIMAL_DATA = `
    query Products($productCodes: [String!]!) {
      products(productCodes: $productCodes) {
        productCode
        variants {
          price
          sku
          genericName
          name
          category
          subcategory
          inStock
          attributes {
              ${attribute}
          }
          magentoBundleOptions {
              ${magentoBundleOptions}
          }
        }
      }
    }
`

export const GET_BUNDLE_CATALOG_DATA = `
    query ($category: CategoryEnum!, $modifiers: [ProductModifier]) {
        productsByCategory(category: $category, modifiers: $modifiers) {
            products {
                ${product}
            }
        }
    }
`
